import React, { useEffect, useState } from 'react';
import TestimonialCard from './TestimonialCard';
import './Hero.css';                       // pad blijft gelijk

export default function Testimonials() {
const reviews = [
  'Onze website is strak, snel en professioneel!',
  'Dankzij de SEO zijn we nu goed vindbaar in Google!',
  'Hele fijne samenwerking én top resultaat behaald!',
  'We zien duidelijk meer bezoekers en aanvragen binnenkomen!',
];




  /* --------- posities voor desktop --------- */
  const positions = [
    { top: '10%', left: '0%' },
    { top: '0%',  left: '35%' },
    { top: '35%', left: '25%' },
    { top: '20%', left: '70%' },
  ];

  /* --------- mobiel-detectie --------- */
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' &&
      window.matchMedia('(max-width: 767.98px)').matches
  );
  useEffect(() => {
    const handler = () =>
      setIsMobile(window.matchMedia('(max-width: 767.98px)').matches);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  /* --------- carousel-logica --------- */
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    if (!isMobile) return;                     // alleen op mobiel
    const id = setInterval(
      () => setCurrent((i) => (i + 1) % reviews.length),
      3000                                      // elke 3 s
    );
    return () => clearInterval(id);
  }, [isMobile, reviews.length]);

  /* --------- render --------- */
  return (
    <div className="testimonial-container position-relative">
      {isMobile ? (
        /* één kaart; key triggert CSS-animatie bij wisselen */
        <TestimonialCard key={current} text={reviews[current]} />
      ) : (
        /* desktop: vier kaarten op vaste posities */
        reviews.map((text, i) => (
          <TestimonialCard key={i} text={text} style={positions[i]} />
        ))
      )}
    </div>
  );
}
